import React from "react";

import Margin from "../../../../shared/Margin";
import NewHeadline from "../../../../shared/NewHeadline";
import Section from "../../../../shared/Section";
import useCalulatorStore from "../../CalculatorPage/store";
import AntiFreeze from "./AntiFreeze";
import ClimateNeutral from "./ClimateNeutral";
import Comment from "./Comment";
import DeliveryTime from "./DeliveryTime";
import Hose from "./Hose";

const StepDeliveryDetails = () => {
    const [additions] = useCalulatorStore((state) => [state.additions]);

    return (
        additions && (
            <>
                <Section>
                    <DeliveryTime />

                    <Section withMargin>
                        <Margin Component={NewHeadline} top="20">
                            Lieferdetails
                        </Margin>

                        {additions.climate_neutral_add && <ClimateNeutral />}

                        {additions.anti_freeze_add && <AntiFreeze />}

                        <Hose />
                    </Section>

                    <Section withMargin>
                        <Comment />
                    </Section>
                </Section>
            </>
        )
    );
};

export default StepDeliveryDetails;
